import React from "react";
import { Button } from "./ui/button";
import { Zap, DollarSign, ChefHat } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="propuesta"
      className="py-28 bg-gradient-to-br from-salbox-primary-200/80 via-salbox-primary-50/50 to-salbox-secondary-200/80 relative overflow-hidden scroll-mt-20"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-salbox-primary-100/50 via-white/80 to-salbox-secondary-100/60"></div>
      <div className="absolute top-0 left-0 w-96 h-96 bg-salbox-primary-200/70 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-salbox-secondary-200/70 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-lufga-semibold text-salbox-primary mb-6 my-8 leading-tight">
            Comer bien deja de ser
            <br />
            <span className="text-salbox-secondary">un lujo</span>
          </h1>
          <p className="text-xl font-lufga text-salbox-neutral-600 max-w-3xl mx-auto mb-8">
            Somos una nueva forma de comer mejor, sin complicaciones. Comida
            casera, calientita y hecha al momento, sin intermediarios y con
            precios justos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="bg-salbox-secondary hover:bg-salbox-secondary-600 text-white font-lufga-medium px-8 py-4"
              onClick={() => {
                const ctaSection = document.getElementById('pide-ya');
                ctaSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Pide Ya!
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-salbox-primary text-salbox-primary hover:bg-salbox-primary hover:text-white font-lufga-medium px-8 py-4"
              onClick={() => {
                const menuSection = document.getElementById('menu');
                menuSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Ver Menú
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:shadow-salbox-secondary/20 transition-all duration-300 cursor-pointer">
            <div className="w-16 h-16 bg-salbox-primary-100 rounded-lg flex items-center justify-center mb-6">
              <Zap className="w-8 h-8 text-salbox-primary" />
            </div>
            <h3 className="text-xl font-lufga-semibold text-salbox-neutral-800 mb-4">
              Entrega Gratis
            </h3>
            <p className="text-salbox-neutral-600 font-lufga">
              Entregamos directamente hasta tu oficina o casa sin costo
              adicional de envío.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:shadow-salbox-secondary/20 transition-all duration-300 cursor-pointer">
            <div className="w-16 h-16 bg-salbox-secondary-100 rounded-lg flex items-center justify-center mb-6">
              <DollarSign className="w-8 h-8 text-salbox-secondary" />
            </div>
            <h3 className="text-xl font-lufga-semibold text-salbox-neutral-800 mb-4">
              Precios Justos
            </h3>
            <p className="text-salbox-neutral-600 font-lufga">
              Sin intermediarios, sin comisiones de apps. Comida de calidad a
              precios accesibles.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:shadow-salbox-secondary/20 transition-all duration-300 cursor-pointer">
            <div className="w-16 h-16 bg-salbox-primary-100 rounded-lg flex items-center justify-center mb-6">
              <ChefHat className="w-8 h-8 text-salbox-primary" />
            </div>
            <h3 className="text-xl font-lufga-semibold text-salbox-neutral-800 mb-4">
              Hecho al Momento
            </h3>
            <p className="text-salbox-neutral-600 font-lufga">
              Todo se cocina al momento en nuestras unidades móviles. Comida
              fresca y caliente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
